import React from 'react';
import AppDocentes from '../../../../components/docentes';
import AppHeader from '../../../../components/Header/Header';
import AppContact from '../../../../components/Contact/contact';
import AppFooter from '../../../../components/Footer/footer';
import BannerSection from '../../../../components/BannerSection';
import SidebarMenu from '../../../../components/SidebarMenu';
import BreadcrumbNav from '../../../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Programa' },
    { label: 'Unidade Orgânica', href: '/programas/unidade-organica' },
    { label: 'Ciências da Saúde', href: '/programas/unidade_organica/ciencia_saude' },
    { label: 'Docentes' }
];

function Docentes() {
    return (
        <>
        <header id='header'>
        <AppHeader />
       </header>
        <BannerSection
        title="Docentes"
        subtitle="Unidade Orgânica de Ciências da Saúde"
        description={`Conheça os docentes da Unidade Orgânica de Ciências da Saúde, profissionais altamente qualificados e dedicados à formação de excelência na área da saúde.`}
        backgroundImage={require('../../../../assets/img-heroUN.jpg')}
        backgroundId="instituition-Banner"
    />
        <BreadcrumbNav items={caminho} />
        <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
        <br />
        <div className="row flex-row-reverse">
            <div className="col-12 col-md-4 col-lg-3 col-xl-2">
            <SidebarMenu
                title="Programas"
                items={[
                { label: "Apresentação", href: "/programas/unidade-organica/ciencia-saude" },
                { label: "Missão Visão e Valores", href: "/programas/unidade-organica/ciencia-saude/missao-visao-valores" },
                { label: "Docentes", href: "/programas/unidade-organica/ciencia-saude/docentes" },
                ]}
            />
            </div>
            <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
            <br />
            <AppDocentes />
            <br /><br />
            </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        </main>
        <AppContact />
        <footer id="footer">
        <AppFooter />
      </footer>
        </>
    );
}

export default Docentes;